import { Stack, ToggleButton, Typography } from "@mui/material";
import Iconify from "src/components/Iconify";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	icon: string;
	value: any;
};

export const ToggleItem = ({ title, icon, value }: Props) => {
	return (
		<ToggleButton sx={{ px: 1.2, height: 32 }} value={value}>
			<Stack flexDirection={"row"} alignItems={"center"} gap={1}>
				<Iconify height={16} icon={icon} width={16} />
				<Typography variant='subtitle2'>{title}</Typography>
			</Stack>
		</ToggleButton>
	);
};

export default ToggleItem;
